module.exports = __webpack_public_path__ + "static/img/icon-st.afa7ee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon-st.jpg
// module id = j2XS
// module chunks = 4